/* eslint-disable @typescript-eslint/lines-between-class-members */
import { Message } from 'yup/lib/types';
import UIStrings from './UIStrings';

export default class YupValidationErrors {
    static readonly Required = 'Required';
    static readonly EmailValidationError = UIStrings.PleaseEnterValidEmailAddress;
    static readonly MaxSymbolsValidationError: Message<{ max: number }> = ({ max }) => `Must not exceed ${max} symbols`;
    static readonly JobTitleMaxSymbolsValidationError: Message<{ max: number }> = ({ max }) =>
        `Job title should not exceed ${max} characters`;
    static readonly NegativeValueError = 'Negative numbers are not allowed. Please enter a positive value.';
    static readonly IncorrectSalaryLimitsError =
        'The minimum salary cannot be greater than the maximum salary. Please adjust your input.';
    static readonly EmptyFieldError = 'This field cannot be empty. Please enter a valid value.';
    static readonly InvalidInputError = 'Invalid input. Please enter a valid format.';
    static readonly SalaryExceedsSystemLimitError = 'Salary exceeds system limit. Please enter a valid amount.';
    static readonly JobAdTitleMaxSymbolsValidationError: Message<{ max: number }> = ({ max }) =>
        `Job ad title should not exceed ${max} characters`;
    static readonly PleaseAddAtLeastOneSkillRequiredError = (skillType: string) =>
        `Please add at least one ${skillType} skill or toggle off the section.`;
    static readonly PleaseAddAtLeastOneCriteriaRequiredError =
        'Please add at least one criteria or toggle off the section.';
    static readonly JobDescriptionRequiredError = 'Please enter job description.';
    static readonly PleaseLimitDescriptionError = 'Please limit description.';
    static readonly CompanyDescriptionLimitError = 'Please limit company description.';
    static readonly GreaterThanZero = 'Please enter a value greater than 0.';
    static readonly AmountCannotExceed = (max: string) => `Annual fixed amount cannot exceed ${max} `;
    static readonly BonusCannotExceed = (max: string) => `Annual target bonus cannot exceed ${max} `;
    static readonly ConstraintNumberError = (min: number, max: number) =>
        `Enter a number between ${min} and ${max}. No letters allowed.`;
    static readonly UrlFieldMustBeAValidUrl =
        'The URL field must be a valid URL. Please make sure that the URL starts with http:// or https://';
    static readonly RecruitersNoteInputLengthValidation = (max: number) =>
        `Note content should not exceed ${max} characters.`;
    static readonly AISearchOneMinimumFilterRequired = 'At least one filter must be defined';
    static readonly AISearchFillEveryRankingCriteriaRequired = 'Every ranking criteria field must be defined';
    static readonly UrlMustBeFromLinkedIn =
        'The LinkedIn URL is invalid. Please enter a valid LinkedIn profile URL (e.g., www.linkedin.com/in/<linkedin-id>)';
}
